module.exports = __webpack_public_path__ + "images/normal-avator.f8f50766df5005b976246ec8db07ec69.png";